import { render, staticRenderFns } from "./SkupEdit.vue?vue&type=template&id=6da397b2&scoped=true&"
import script from "./SkupEdit.vue?vue&type=script&lang=js&"
export * from "./SkupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da397b2",
  null
  
)

export default component.exports